// export const experienceData = [
//     {
//         id: 1,
//         company: 'Brigade Group',
//         jobtitle: 'React Fullstack Developer',
//         startYear: '2025',
//         endYear: 'Present'
//     },
//     {
//         id: 2,
//         company: 'Integra Group',
//         jobtitle: 'React Fullstack Developer',
//         startYear: '2024',
//         endYear: '2025'
//     },
//     {
//         id: 3,
//         company: 'Sujanix Pvt Ltd.',
//         jobtitle: 'React Fullstack Developer',
//         startYear: '2022',
//         endYear: '2024'
//     }
//     ,
//     {
//         id: 4,
//         company: 'B.I.V. technologies',
//         jobtitle: 'junior software developer',
//         startYear: '2021',
//         endYear: '2022'
//     },
// ]

export const experienceData = [
  {
    id: 1,
    company: 'Brigade Group',
    role: 'Software Engineer',
    duration: '2025 - Present',
    tech: ['React JS', 'Next JS', 'React Native'],
    domain: 'Enterprise Mobility & Smart Community Solutions',
    description:
      'Building scalable web and mobile applications with React ecosystem and modern frontend architecture.',
  },
  {
    id: 2,
    company: 'Integra Group',
    role: 'React & React Native Developer',
    duration: '2024 - 2025',
    tech: ['React JS', 'React Native', 'Yarn Workspaces'],
    domain: 'Cross-platform Application Development',
    description:
      'Worked on modular monorepo architecture using Yarn workspaces for scalable frontend development.',
  },
  {
    id: 3,
    company: 'Sujanix Pvt Ltd.',
    role: 'Software Engineer',
    duration: '2022 - 2024',
    tech: [
      'PHP',
      'MySQL',
      'Laravel',
      'React JS',
      'React Native',
      'MDM',
    ],
    domain: 'Device Management & Business Applications',
    description:
      'Developed mobile and web solutions including Android MDM systems and business management platforms.',
  },
  {
    id: 4,
    company: 'B.I.V. Technologies',
    role: 'Junior Software Developer',
    duration: '2021 - 2022',
    tech: ['PHP', 'MySQL', 'React JS', 'React Native'],
    domain: 'Web & Mobile Application Development',
    description:
      'Started professional journey building fullstack web and mobile applications.',
  },
];